import axios from "axios";
import Env from "/env";
import Vue from "vue";

const adminHttpImg = axios.create({
    baseURL: `${Env.API_URL}`,
    headers: {
        "Content-Type": "multipart/form-data",
    }
})

/**
 * Request Interceptors
 */
const getAuthToken = () => localStorage.getItem('token')
const authInterceptor = (config) => {
    const token = getAuthToken()
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    config.headers['Accept-Language'] = 'ru'
    return config
}
adminHttpImg.interceptors.request.use(authInterceptor)

const AUTH_PATH = '/auth'

const handleUnauthorized = () => {
    if (window.location.pathname === AUTH_PATH) return
    localStorage.clear()
    window.location.href = AUTH_PATH
}

const WRITE_METHODS = ['post', 'put', 'patch', 'delete']

const extractErrorMessage = (e) => {
    const data = e?.response?.data
    if (data?.errors && typeof data.errors === 'object') {
        const messages = Object.values(data.errors).flat().filter(Boolean)
        if (messages.length) return messages.join('\n')
    }
    if (typeof data?.message === 'string' && data.message) return data.message
    if (typeof data === 'string' && data) return data
    if (e?.message) return e.message
    return 'Произошла ошибка при выполнении запроса'
}

const errorInterceptor = e => {
    const status = e?.response?.status
    const config = e?.config || e?.response?.config || {}
    switch (status) {
        case 401:
            console.log('###', status, e.message)
            handleUnauthorized()
            break
        case 403:
            Vue.toasted.error('У вашей роли нет доступа', {
                duration: 5000
            });
            break
        default:
            if(process.env.NODE_ENV === 'development')
                console.log('### ', status, e.message, e?.response)
            if (!config.skipErrorToast) {
                Vue.toasted.error(extractErrorMessage(e), {
                    duration: 5000
                });
            }
    }
    return Promise.reject(e)
}

const responseInterceptor = r => {
    const method = (r?.config?.method || '').toLowerCase()
    if (!r?.config?.skipSuccessToast && WRITE_METHODS.includes(method)) {
        const message = (typeof r?.data?.message === 'string' && r.data.message)
            ? r.data.message
            : 'Успешно'
        Vue.toasted.success(message, {
            duration: 3000
        })
    }
    return r
}

adminHttpImg.interceptors.response.use(responseInterceptor, errorInterceptor)

export default adminHttpImg;